module.exports = __webpack_public_path__ + "static/img/jxhd-3.3f58aebe.png";